<template>
    <header>
        <a class="home-link" href="https://uni-dubna.ru">
            <img src="../assets/unilogo.png">

        </a>
    </header>
</template>

<script>
    export default {
        name: "MainHeader"
    }
</script>

<style scoped>
    header{
        text-align: center;
    }

    .home-link img{
        width: 150px ;
    }

    @media (max-width: 850px){
        .home-link img{
            width: 100px ;
        }

    }

</style>